import {http, httpCustom} from './config';

export default {
    show: lotId => httpCustom.get(`api/v1/lotes/${lotId}`),
    showOnlyReserve: lotId => httpCustom.get(`api/v1/lotes/${lotId}`, {params: {onlyReserve: true}}),
    showOnlyReadjustment: lotId => httpCustom.get(`api/v1/lotes/${lotId}`, {params: {onlyReadjustment: true}}),
    list: () => httpCustom.get('api/v1/lotes/listar'),
    create: lot => httpCustom.post('api/v1/lotes', lot),
    update: (lotId, lot) => httpCustom.put(`api/v1/lotes/${lotId}`, lot),
    delete: lotId => httpCustom.delete(`api/v1/lotes/${lotId}`),
    blocks: allotmentId => httpCustom.get('api/v1/lotes/quadras/listar', {headers: {'allotment-id': allotmentId}}),
    getLotsByAllotment: allotmentId => httpCustom.get(`api/v1/lotes/loteamento/${allotmentId}`),
    blocksList: (allotmentId, withReserve, statusId = null, stepId = null, propertyStatusId = null, ownerId = null) =>
            httpCustom.get('api/v1/lotes/quadras/listar', {
                params: {'with-reserve': withReserve, statusId, stepId,propertyStatusId, ownerId},
                headers: {'allotment-id': allotmentId},
            }),
    listStepsByStatusLot:(allotmentId, statusId) =>
            httpCustom.get('api/v1/etapasLoteamentos/listar', {
                params: {statusId, 'forStatusAllot': true},
                headers: {'allotment-id': allotmentId},
            }),
    blocksListActivesAndBlocked: (allotmentId, scope) => {
        if (!scope){
            return httpCustom.get(`api/v1/lotes/quadras/listarAtivosBloqueados/${allotmentId}`);
        }
        return http.get(`api/v1/lotes/quadras/listarAtivosBloqueados/${allotmentId}`);
    },
    blocksListAvailable: allotmentId => httpCustom.get('api/v1/lotes/quadras/listarDisponiveis', {headers: {'allotment-id': allotmentId}}),
    lotsByAllotmentAndBlock: (allotmentId, blockId, statusId = null, stepId = null, propertyStatusId = null, ownerId = null) => {
        return httpCustom.get(`api/v1/lotes/${allotmentId}/${blockId}`, {
            params: {statusId, stepId, propertyStatusId, ownerId}
        });
    },
    listModified: (time, allotmentId) => httpCustom.get(`api/v1/lotes/listarModificados/${time}`, {headers: {'allotment-id': allotmentId}}),
    showLotProperties: (allotmentId, blockId) => httpCustom.get(`api/v1/lotes/verDisponiveis/${allotmentId}/${blockId}`),
    getTypesLotes: allotmentId => http.get('api/v1/tipoPropriedades/listar', {headers: {'allotment-id': allotmentId}}),
    import: (file, allotmentId) => {
        const formData = new FormData();
        formData.append('file', file);
        return httpCustom.post('api/v1/importar/lotes', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'allotment-id': allotmentId,
            },
        });
    },
    export: allotmentId => httpCustom.get('/api/v1/exportar/lotes', {
        responseType: 'blob',
        headers: {'allotment-id': allotmentId},
    }),
};
